import { AccessFunctionFieldUpdateCallback } from 'data/accessFunction/accessFunction.types';
import { useAccessFunctionFieldCreateNewNetwork } from './useAccessFunctionFieldCreateNewNetwork';
import { useAccessFunctionFieldCreateNewSecurityInfo } from './useAccessFunctionFieldCreateNewSecurityInfo';
import {
  useDialedDigitExtractionServerFieldCreateNewNetworkInterface,
} from './useDialedDigitExtractionServerFieldCreateNewNetworkInterface';

// eslint-disable-next-line import/prefer-default-export
export function useAccessFunctionFieldCreateNew(
  handleFieldUpdate: AccessFunctionFieldUpdateCallback,
): [AccessFunctionFieldUpdateCallback] {
  const [handleFieldNetwork] = useAccessFunctionFieldCreateNewNetwork(handleFieldUpdate);
  const [handleFieldSecurityInfo] = useAccessFunctionFieldCreateNewSecurityInfo(handleFieldUpdate);
  const [
    handleFieldDeliveryFunctionNetworkInterface,
  ] = useDialedDigitExtractionServerFieldCreateNewNetworkInterface(handleFieldUpdate);

  const handleFieldCreateNew: AccessFunctionFieldUpdateCallback = (param, formSection, interfaceId) => {
    const { name } = param;

    if (
      formSection === 'provisioningInterfaces'
      || formSection === 'dataInterfaces'
      || formSection === 'contentInterfaces'
      || formSection === 'diameter'
      || formSection === 'monitoringCenters'
      || formSection === 'usnbdAgencies'
      || formSection === 'usnbdCallDataChannels') {
      if (name === 'ownnetid' || name === 'ccnetid' || name === 'cdnetid') {
        handleFieldNetwork(param, formSection, interfaceId);
      } else if (name === 'secinfoid') {
        handleFieldSecurityInfo(param, formSection, interfaceId);
      } else if (name === 'niid') {
        handleFieldDeliveryFunctionNetworkInterface(param, formSection, interfaceId);
      }
    }
  };

  return [handleFieldCreateNew];
}
